<template>
<svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.3421 5.23684C3.3421 2.62076 5.46286 0.5 8.07894 0.5C10.695 0.5 12.8158 2.62076 12.8158 5.23684V8.07895C12.8158 10.695 10.695 12.8158 8.07894 12.8158C5.46286 12.8158 3.3421 10.695 3.3421 8.07895V5.23684Z" stroke="white"/>
<path d="M7.1333 5.23682H9.02804" stroke="white" stroke-linecap="round"/>
<path d="M6.1842 8.07886H9.97368" stroke="white" stroke-linecap="round"/>
<path d="M15.6579 7.13159V8.07896C15.6579 12.2647 12.2647 15.6579 8.07895 15.6579C3.89321 15.6579 0.5 12.2647 0.5 8.07896V7.13159" stroke="white" stroke-linecap="round"/>
<path d="M8.07892 15.658V18.5001" stroke="white" stroke-linecap="round"/>
</svg>
</template>

<script>
export default {
  name: 'IconMicrophone'
}
</script>
